import React, { Fragment, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { formatMessage } from "../../utils/MyFunctions";
import { useIntl, FormattedMessage } from "react-intl";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Avatar,
  Hidden,
  IconButton,
  Box,
  Typography,
  Tabs,
  Tab,
  Card,
  Tooltip,
  Popover,
  Badge,
  Button,
  List,
  ListItem,
  LinearProgress,
  FormControl,
  FormLabel,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Divider,
} from "@material-ui/core";

import avatar1 from "../../assets/images/avatars/avatar1.jpg";
import avatar2 from "../../assets/images/avatars/avatar2.jpg";
import avatar6 from "../../assets/images/avatars/avatar6.jpg";
import avatar7 from "../../assets/images/avatars/avatar7.jpg";
import people1 from "../../assets/images/stock-photos/people-1.jpg";
import people3 from "../../assets/images/stock-photos/people-3.jpg";
import parse from "html-react-parser";
import userContext from "contexts/userContext";

import NotificationsActiveTwoToneIcon from "@material-ui/icons/NotificationsActiveTwoTone";
import PollTwoToneIcon from "@material-ui/icons/PollTwoTone";
import PeopleAltTwoToneIcon from "@material-ui/icons/PeopleAltTwoTone";
import ReplayIcon from "@material-ui/icons/Replay";
import { AuthContext } from "utils/AuthContext";
import httpService from "utils/HttpService";
import helper from "utils/Helper";
import Chart from "react-apexcharts";
import { parseWithOptions } from "date-fns/esm/fp";
import {
  fetcher,
  add,
  del,
  blank,
  closeSnack,
  notify,
} from "utils/MyFunctions";
import FeedbackContext from "contexts/feedbackContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function HeaderDots() {
  const intl = useIntl();
  const visible = process.env.REACT_APP_COMMITTED_AMOUNT_VISIBLE;
  const history = useHistory();
  const BILLING_API_URL = process.env.REACT_APP_BILLING_API_URL;
  const MONOLITH_API_URL = process.env.REACT_APP_MONOLITH_API_URL;
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    FeedbackContext
  );
  const SECURITY_API_URL =
    // "http://127.0.0.1:8300/api/";
    process.env.REACT_APP_SECURITY_API_URL;

  const { role, setRole } = useContext(userContext);
  const { isAuthenticated, login, logout } = useContext(AuthContext);
  const [balanceLoading, setBalanceLoading] = React.useState(false);
  const [shipper, setShipper] = React.useState({});
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const [anchorEl4, setAnchorEl4] = React.useState(null);
  const [authenticatedUser, setAuthenticatedUser] = React.useState(null);
  const [unreadNotifications, setUnreadNotifications] = React.useState([]);
  const [readNotifications, setReadNotifications] = React.useState([]);

  const getSymbol = (s) => {
    let _s = s.toLowerCase();
    let dic = {
      xaf: "XAF",
      usd: "$",
      eur: "€",
    };
    return dic[_s];
  };

  useEffect(() => {
    // console.log("role changed(HeaderDots) : ", role);
  }, [role]);

  const initials = (name) => {
    let arr = name.split(" ");
    return (
      arr[arr.length - 1].charAt(0).toUpperCase() +
      arr[0].charAt(0).toUpperCase()
    );
  };

  const refreshBalance = () => {
    setBalanceLoading(true);

    axios
      .all([
        axios.post(
          MONOLITH_API_URL + "/bescs/montant-engage",
          {
            company_uuid: role.user.company.unique_identification,
          },
          {
            headers: {
              "Content-Type": "application+json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
            },
          }
        ),
        axios.post(
          BILLING_API_URL + "/api/shipper/account",
          {
            unique_identification: role.user.company.unique_identification,
          },
          {
            headers: {
              "Content-Type": "application+json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
            },
          }
        ),
      ])
      .then(
        axios.spread((obj1, obj2) => {
          // Both requests are now complete
          console.log(obj1.data);
          console.log(obj2.data);

          console.log(
            "SETTING ROLE ADDING BALANCE AND MONTANT ENGAGE, current role : ",
            role
          );
          if (obj1.data.status === "ok" && obj2.data.success) {
            console.log("obj1 : ", obj1);
            console.log("obj2 : ", obj2);
            setRole((role) => ({
              ...role,
              shipper: obj2.data.account,
              dette:
                obj1.data.dette.length > 0 ? obj1.data.dette[0].valeur : null,
              deviseDette:
                obj1.data.dette.length > 0 ? obj1.data.dette[0].devise : null,
            }));
          } else {
            setRole((role) => ({
              ...role,
              shipper: {
                raison_social: "CNCC",
                balance: 0,
              },
            }));
          }
          setBalanceLoading(false);
        })
      );

    // axios
    //   .request(config)
    //   .then((response) => {
    //     console.log("sucess!! response below :");
    //     console.log(JSON.stringify(response.data));
    //     if (response.data.success) {
    //       setRole({
    //         ...role,
    //         shipper: response.data.account,
    //       });
    //       setShipper(response.data.account);
    //     } else {
    //       setRole({
    //         ...role,
    //         shipper: {
    //           raison_social: "CNCC",
    //           balance: 0,
    //         },
    //       });
    //     }

    //     setBalanceLoading(false);
    //   })
    //   .catch((error) => {
    //     console.log("error!! error below :");
    //     console.log(error);
    //   });
  };

  useEffect(() => {
    console.log("shipper changed, shipper : ", shipper);
  }, [shipper]);

  useEffect(() => {
    let user = localStorage.getItem("USER");
    if (user) {
      setAuthenticatedUser(JSON.parse(user));
    }

    if (
      role.user &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name
      )
    ) {
      setBalanceLoading(true);

      axios
        .all([
          axios.post(
            MONOLITH_API_URL + "/bescs/montant-engage",
            {
              company_uuid: role.user.company.unique_identification,
            },
            {
              headers: {
                "Content-Type": "application+json",
                Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
              },
            }
          ),
          axios.post(
            BILLING_API_URL + "/api/shipper/account",
            {
              unique_identification: role.user.company.unique_identification,
            },
            {
              headers: {
                "Content-Type": "application+json",
                Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
              },
            }
          ),
        ])
        .then(
          axios.spread((obj1, obj2) => {
            // Both requests are now complete
            console.log(obj1.data);
            console.log(obj2.data);
            console.log(
              "SETTING ROLE ADDING BALANCE AND MONTANT ENGAGE, current role : ",
              role
            );
            if (obj1.data.status === "ok" && obj2.data.success) {
              console.log("obj1 : ", obj1);
              console.log("obj2 : ", obj2);
              setRole((role) => ({
                ...role,
                shipper: obj2.data.account,
                dette:
                  obj1.data.dette.length > 0 ? obj1.data.dette[0].valeur : null,
                deviseDette:
                  obj1.data.dette.length > 0 ? obj1.data.dette[0].devise : null,
              }));
            } else {
              setRole((role) => ({
                ...role,
                shipper: {
                  raison_social: "CNCC",
                  balance: 0,
                  credit_terms: 0,
                },
              }));
            }
            setBalanceLoading(false);
          })
        );
    } else {
      console.log(
        "SETTING ROLE ADDING BALANCE AND MONTANT ENGAGE, current role : ",
        role
      );
      setRole((role) => ({
        ...role,
        shipper: {
          raison_social: "CNCC",
          balance: 0,
        },
      }));
      setBalanceLoading(false);
    }
    getNotifications();
  }, []);

  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const handleClick4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };
  const handleClose4 = () => {
    setAnchorEl4(null);
  };

  const open1 = Boolean(anchorEl1);
  const open2 = Boolean(anchorEl2);
  const open3 = Boolean(anchorEl3);
  const open4 = Boolean(anchorEl4);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeC = (event) => {};
  const handleSignOut = () => {
    setFeedback({ ...feedback, ["bdOpen"]: true });
    let sb = notify(
      "Traitement en cours...",
      "info",
      "center",
      "bottom",
      false,
      enqueueSnackbar
    );
    httpService
      .postWithHeader(SECURITY_API_URL + "logout/user", {})
      .then((response) => {
        if (response.data.success) {
          localStorage.clear();
          logout();
          history.push("/Accueil");
        }
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnack(sb, closeSnackbar);
        notify(
          response.data.ResponseText,
          response.data.success ? "success" : "error",
          "center",
          "top",
          true,
          enqueueSnackbar
        );
      })
      .catch((error) => {
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnack(sb, closeSnackbar);
        if (error.response && error.response.status === 401) {
          // alert(`Votre session a expiré. Veuillez vous reconnecter`);
          notify(
            "Votre session a expiré. Veuillez vous reconnecter",
            "info",
            "center",
            "top",
            true,
            enqueueSnackbar
          );
          localStorage.clear();
          logout();
          history.push("/");
        }else{
          localStorage.clear();
          logout();
          history.push("/")
        }
      });
  };
  const getNotifications = () => {
    httpService
      .getWithHeader(SECURITY_API_URL + "notifications")
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setUnreadNotifications(response.data.unreadNotifications);
          setReadNotifications(response.data.readNotifications);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          logout();
          history.push("/");
        }
      });
  };

  const gotoProfile = () => {
    history.push("/Profile");
  };

  const makeAsRead = (id) => {
    httpService
      .postWithHeader(SECURITY_API_URL + "markRead", { id: id })
      .then((response) => {
        if (response.data.success) {
          setUnreadNotifications(response.data.unreadNotifications);
          setReadNotifications(response.data.readNotifications);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          logout();
          history.push("/");
        }
      });
  };

  return (
    <Fragment>
      <div className="d-flex align-items-center popover-header-wrapper">
        {/*    <Hidden smDown>   </Hidden>*/}
        <Box component="span" pr="2">
          <IconButton
            onClick={handleClick1}
            color="inherit"
            className="btn-inverse mx-1 d-50"
          >
            <div className="badge badge-pill badge-warning badge-header">
              {unreadNotifications.length}
            </div>
            <NotificationsActiveTwoToneIcon />
          </IconButton>
          <Popover
            open={open1}
            anchorEl={anchorEl1}
            onClose={handleClose1}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            classes={{
              paper: "app-header-dots",
            }}
          >
            <div className="popover-custom-xl overflow-hidden">
              <div className="bg-composed-wrapper bg-midnight-bloom border-0 text-center rounded-sm m-2">
                <div className="bg-composed-img-3 bg-composed-wrapper--image"></div>
                <div className="bg-composed-wrapper--content text-light px-2 py-4">
                  <h4 className="font-size-xl font-weight-bold mb-2">
                    {formatMessage(intl, "header_dots_notifications_title")}
                  </h4>
                  <p className="opacity-8 mb-0">
                    <b className="text-success">
                      {intl.formatMessage(
                        { id: "header_dots_notifications_description" },
                        { itemCount: unreadNotifications.length }
                      )}
                    </b>
                  </p>
                </div>
              </div>
              <div className="mx-2">
                <Tabs
                  value={value}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  onChange={handleChange}
                >
                  <Tab
                    className="py-3"
                    label={formatMessage(intl, "header_dots_tab_notifications")}
                  />
                  <Tab
                    className="py-3"
                    label={formatMessage(intl, "header_dots_tab_history")}
                  />
                </Tabs>
              </div>
              <div className="height-280">
                <PerfectScrollbar>
                  <TabPanel value={value} index={0}>
                    {unreadNotifications.length == 0 && (
                      <div className="text-center my-2">
                        <div className="avatar-icon-wrapper rounded-circle m-0">
                          <div className="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
                            <FontAwesomeIcon
                              icon={["fas", "times"]}
                              className="d-flex align-self-center display-3"
                            />
                          </div>
                        </div>
                        <h6 className="font-weight-bold font-size-lg mb-1 mt-4 text-black">
                          {formatMessage(
                            intl,
                            "header_dots_tab_notifications_no_message"
                          )}
                        </h6>
                      </div>
                    )}
                    {unreadNotifications.length > 0 && (
                      <List>
                        <PerfectScrollbar className="scroll-area">
                          {unreadNotifications.map((notification) => (
                            <Fragment>
                              <ListItem className="hover-show-hide-container d-flex justify-content-between align-items-center py-3 border-0">
                                {notification.data.notificationData.priority ==
                                  0 && (
                                  <span className="badge-circle mt-2 mr-2 align-self-start badge badge-danger">
                                    Basic
                                  </span>
                                )}
                                {notification.data.notificationData.priority ==
                                  1 && (
                                  <span className="badge-circle mt-2 mr-2 align-self-start badge badge-warning">
                                    Basic
                                  </span>
                                )}
                                {notification.data.notificationData.priority ==
                                  2 && (
                                  <span className="badge-circle mt-2 mr-2 align-self-start badge badge-info">
                                    Basic
                                  </span>
                                )}
                                {notification.data.notificationData.priority ==
                                  3 && (
                                  <span className="badge-circle mt-2 mr-2 align-self-start badge badge-success">
                                    Basic
                                  </span>
                                )}
                                <div className="font-weight-bold flex-grow-1">
                                  {notification.data.notificationData && (
                                    <div className="text-second">
                                      {
                                        notification.data.notificationData
                                          .subject
                                      }
                                    </div>
                                  )}
                                  <span className="opacity-8">
                                    {parse(
                                      helper.getText(notification.data.message)
                                    )}
                                  </span>
                                  <div className="text-right hover-hide-wrapper">
                                    <span className="opacity-7">
                                      {notification.timeAgo}
                                    </span>
                                  </div>
                                </div>

                                <div className="text-right hover-show-wrapper">
                                  <Tooltip
                                    arrow
                                    title={formatMessage(
                                      intl,
                                      "header_dots_tab_notifications_btn_mark_as_read"
                                    )}
                                  >
                                    <IconButton
                                      className="bg-white text-success d-40 rounded-circle ml-1"
                                      onClick={() => {
                                        makeAsRead(notification.id);
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={["fas", "check"]}
                                        className="font-size-md mx-auto"
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </ListItem>
                              <Divider />
                            </Fragment>
                          ))}
                        </PerfectScrollbar>
                      </List>
                    )}
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <div className="timeline-list timeline-list-offset timeline-list-offset-dot">
                      <div className="timeline-item">
                        <div className="timeline-item-offset">9:25</div>
                        <div className="timeline-item--content">
                          <div className="timeline-item--icon"></div>
                          <h4 className="timeline-item--label mb-2 font-weight-bold">
                            1991
                          </h4>
                          <p>
                            The World Wide Web goes live with its first web
                            page.
                          </p>
                        </div>
                      </div>
                      <div className="timeline-item">
                        <div className="timeline-item-offset">9:25</div>
                        <div className="timeline-item--content">
                          <div className="timeline-item--icon"></div>
                          <h4 className="timeline-item--label mb-2 font-weight-bold">
                            Java exam day
                          </h4>
                          <p>
                            Bill Clinton's presidential scandal makes it online.
                          </p>
                          <div className="avatar-wrapper-overlap mt-2 mb-1">
                            <div className="avatar-icon-wrapper avatar-icon-sm">
                              <div className="avatar-icon">
                                <img alt="..." src={avatar1} />
                              </div>
                            </div>
                            <div className="avatar-icon-wrapper avatar-icon-sm">
                              <div className="avatar-icon">
                                <img alt="..." src={avatar2} />
                              </div>
                            </div>
                            <div className="avatar-icon-wrapper avatar-icon-sm">
                              <div className="avatar-icon">
                                <img alt="..." src={avatar6} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="timeline-item">
                        <div className="timeline-item-offset">9:25</div>
                        <div className="timeline-item--content">
                          <div className="timeline-item--icon"></div>
                          <h4 className="timeline-item--label mb-2 font-weight-bold">
                            Business investor meeting
                          </h4>
                          <p>
                            Mosaic, the first graphical browser, is introduced
                            to the average consumer.
                          </p>
                          <div className="mt-3">
                            <a href="#/" onClick={(e) => e.preventDefault()}>
                              <img
                                alt="..."
                                className="img-fluid rounded mr-3 shadow-sm"
                                src={people1}
                                width="70"
                              />
                            </a>
                            <a href="#/" onClick={(e) => e.preventDefault()}>
                              <img
                                alt="..."
                                className="img-fluid rounded shadow-sm"
                                src={people3}
                                width="70"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="timeline-item">
                        <div className="timeline-item-offset">9:25</div>
                        <div className="timeline-item--content">
                          <div className="timeline-item--icon"></div>
                          <h4 className="timeline-item--label mb-2 font-weight-bold">
                            Learning round table gathering
                          </h4>
                          <p>First ever iPod launches.</p>
                          <div className="mt-2">
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                            >
                              Submit Report
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="timeline-item">
                        <div className="timeline-item-offset">9:25</div>
                        <div className="timeline-item--content">
                          <div className="timeline-item--icon"></div>
                          <h4 className="timeline-item--label mb-2 font-weight-bold">
                            2003
                          </h4>
                          <p>
                            MySpace becomes the most popular social network.
                          </p>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </PerfectScrollbar>
              </div>
              <Divider />
              <div className="text-center py-3">
                <Badge
                  color="error"
                  variant="dot"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Button color="primary" variant="contained" className="px-4">
                    <span className="btn-wrapper--label">
                      {formatMessage(
                        intl,
                        "header_dots_tab_notifications_btn_see_all"
                      )}
                    </span>
                    <span className="btn-wrapper--icon">
                      <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                    </span>
                  </Button>
                </Badge>
              </div>
            </div>
          </Popover>
        </Box>

        {/* TESTING ANOTHER BOX WITH POPOVER */}
        <Box component="span" pr="2">
          <IconButton
            onClick={handleClick4}
            color="inherit"
            className="btn-inverse mx-1 d-50"
          >
            <Badge
              overlap="circle"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
            >
              <Avatar
                alt="Travis Howard"
                src={role.user ? role.user.profile_photo_path : ""}
              />
            </Badge>
          </IconButton>
          <Popover
            open={open4}
            anchorEl={anchorEl4}
            onClose={handleClose4}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <ul className="list-group list-group-flush text-left bg-transparent">
              <li className="list-group-item rounded-top">
                <div className="align-box-row">
                  <div className="avatar-icon-wrapper avatar-initials avatar-icon-l">
                    <div className="avatar-icon text-white bg-success">
                      {role.user && role.user.name && initials(role.user.name)}
                    </div>
                  </div>
                  <div className="pl-2">
                    <span className="pb-1 d-block">
                      {role.user && role.user.surname}
                    </span>
                    {/* <div className="divider my-2"></div> */}
                    <div className="pb-1 d-block text-info">
                      {role.user &&
                        role.user.company &&
                        role.user.company.raison_sociale}
                    </div>
                    {role.user && role.user.roles && (
                      <small className="pb-1 text-black-50 d-block">
                        {role && role.user && role.user.poste}
                      </small>
                    )}
                  </div>
                </div>
              </li>

              <li className="list-group-item rounded-top">
                <List className="py-0">
                  <div className="align-box-column">
                    <ListItem
                      button
                      className="align-box-row"
                      onClick={() => {
                        gotoProfile();
                      }}
                    >
                      <div className="d-flex align-items-center">
                        {formatMessage(intl, "header_dots_profile_my_account")}
                      </div>
                      <div className="ml-auto">
                        <FontAwesomeIcon
                          icon={["fas", "angle-right"]}
                          className="text-primary"
                        />
                      </div>
                    </ListItem>
                    {/* <ListItem button className="align-box-row">
                      <div className="d-flex align-items-center">
                        {formatMessage(intl, "header_dots_profile_settings")}
                      </div>
                      <div className="ml-auto">
                        <FontAwesomeIcon
                          icon={["fas", "angle-right"]}
                          className="text-primary"
                        />
                      </div>
                    </ListItem>
                    <ListItem button className="align-box-row">
                      <div className="d-flex align-items-center">
                        {formatMessage(intl, "header_dots_profile_tasks")}
                      </div>
                      <div className="ml-auto">
                        <FontAwesomeIcon
                          icon={["fas", "angle-right"]}
                          className="text-primary"
                        />
                      </div>
                    </ListItem> */}
                  </div>
                </List>
              </li>
              {role.user &&
                ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                  role.user.roles[0].name
                ) && (
                  <li className="list-group-item rounded-top">
                    <div className="px-3 pt-3 pb-2">
                      {balanceLoading ? (
                        <div className="flex-item">
                          <LinearProgress variant="query" />
                        </div>
                      ) : (
                        <>
                          <div className="text-uppercase text-muted mt-0 pt-0 mb-0 pb-0">
                            {formatMessage(intl, "header_dots_profile_balance")}
                            <IconButton
                              onClick={() => {
                                refreshBalance();
                              }}
                            >
                              <ReplayIcon />
                            </IconButton>
                          </div>
                          <div className="d-flex align-items-center pt-0 mt-0 font-weight-bold display-4">
                            <FontAwesomeIcon
                              icon={["fa", "coins"]}
                              className="text-warning mr-2"
                            />
                            {intl.formatNumber(
                              role && role.shipper && role.shipper.balance,
                              {
                                style: "currency",
                                currency:
                                  role &&
                                  role.user &&
                                  role.user.company.currency,
                              }
                            )}
                            {/* {getSymbol(role.user.company.currency)}
                            {role && role.shipper && role.shipper.balance} */}
                          </div>

                          {role.dette && visible === "true" && (
                            <>
                              <div className="text-uppercase text-muted mt-2">
                                {formatMessage(
                                  intl,
                                  "header_dots_profile_amount_engaged"
                                )}
                              </div>
                              <div className="d-flex align-items-center pt-0 mt-0 font-weight-bold display-4">
                                <FontAwesomeIcon
                                  icon={["fa", "coins"]}
                                  className="text-warning mr-2"
                                />

                                {intl.formatNumber(
                                  role &&
                                    role.user.company.currency === "XAF" &&
                                    role.deviseDette === "EUR"
                                    ? role.dette * 656
                                    : role.dette,
                                  {
                                    style: "currency",
                                    currency: role.user.company.currency,
                                  }
                                )}
                                {/* {role &&
                                  role.deviseDette &&
                                  getSymbol(role.deviseDette)}
                                {role && role.dette} */}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </li>
                )}
            </ul>
            <div className="card-footer bg-white p-3 text-center d-block">
              <Button
                variant="outlined"
                size="small"
                color="default"
                onClick={() => {
                  handleSignOut();
                }}
              >
                <span className="btn-wrapper--icon">
                  <FontAwesomeIcon icon={["fas", "sign-out-alt"]} />
                </span>
                <span className="btn-wrapper--label">
                  {formatMessage(intl, "header_dots_btn_logout")}
                </span>
              </Button>
            </div>
          </Popover>
        </Box>
      </div>
    </Fragment>
  );
}
